var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292.78,
    height: 91.04,
    viewBox: "0 40 292.78 91.04",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#343434; !important}.st1{fill:#FFAE00;}.st2{fill:#272727;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.03,-14.48)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m110.3 75.49h25.23c3.85 0 11.44 0.17 15.6 6.33 1.62 2.39 2.79 6.07 2.41 11.12-0.55 7.27-3.65 12.14-6.71 15.31-6.21 6.41-13.81 7.36-19.11 7.36h-8.64l-3.88 19.75h-16.77zm11.39 26.94h4.79c1.97 0 5.24-0.25 7.36-2.39 1.39-1.45 2.15-3.51 2.28-5.22 0.12-1.54-0.29-2.99-0.98-4.02-1.23-1.79-3.52-2.14-5.91-2.14h-4.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m173.58 75.49h20.35l9.43 59.86h-17.62l-1.28-10.35h-20.35l-5.57 10.35h-18.13zm-3.67 36.35h13.68l-2.7-22.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m217.19 112.09-13.41-36.6h18.9l6.51 21.38 14.78-21.38h17.96l-27.98 36.6-4.57 23.26h-16.76z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "22.51 54.48 103.88 54.48 85.4 145.52 4.03 145.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m64.76 64.88c4.42 0 10.93 0.2 15.1 4.71 1.95 2.11 3.7 5.52 3.3 10.74-0.49 6.52-3.52 10.84-7.35 13.65-2.66 2.01-5.76 3.11-6.68 3.41l-0.02 0.2c3.06 0.7 6.24 2.41 8.28 4.72 1.85 2.11 3.58 5.72 3.17 11.14-0.48 6.32-3.24 11.04-7.02 14.65-2.92 2.71-8.86 7.02-20 7.02h-35.92l13.92-70.24zm-15.88 56.19c2.71 0 5.53-0.1 8.04-1.51 2.2-1.2 3.76-3.31 4-6.52 0.22-2.91-1.08-4.31-1.93-5.02-1.71-1.31-4.51-1.4-7.22-1.4h-8.83l-2.9 14.45zm5.06-28.49c1.61 0 4.73-0.2 6.94-1.51 2.84-1.71 3.33-4.21 3.46-6.02 0.13-1.7-0.23-3.61-1.95-4.82s-4.62-1.31-5.72-1.31h-8.23l-2.73 13.65h8.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m243.74 131.96c-0.17 2.28-1.93 3.4-3.6 3.4-1.43 0-2.8-0.82-2.65-2.79 0.17-2.27 1.93-3.4 3.6-3.4 1.43-0.01 2.8 0.81 2.65 2.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m255.13 113.57h5.84l1.31 12.95 6.3-12.95h5.97l-1.11 21.24h-5.6l0.74-12.32-5.98 12.32h-3.84l-1.27-12.32-3.97 12.32h-5.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m280 113.57h7.79c2.1 0 5.86 0.18 7.85 3.28 1.15 1.76 1.26 3.88 1.12 5.79-0.27 3.64-1.52 6.43-3.91 8.71-3.08 2.94-6.53 3.46-9.15 3.46h-7.91zm3.45 16.14c1.77 0 3.53-0.33 5.06-1.76 1.6-1.49 1.94-3.15 2.04-4.43 0.14-1.91-0.35-2.97-0.83-3.52s-1.57-1.33-4.1-1.33h-0.67l-2.17 11.04z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpay);
export default __webpack_public_path__ + "static/media/bpay.cb0008a9b3b9f947e7a613ef1e4d46ab.svg";
export { ForwardRef as ReactComponent };